var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"workspace posire"},[_c('section',{staticClass:"workspace-module"}),_c('section',[_c('ApproveList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }